<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>区域管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-select
              v-model="searchForm.city_id"
              placeholder="请选择城市"
              clearable
              size="small"
              @change="searchChange"
              @clear="clearInput"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.title"
              autocomplete="off"
              maxlength="30"
              placeholder="请输入区县"
              @change="searchChange"
              @clear="clearInputs"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="small"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-plus"
              type="success"
              @click="handleNewAdd"
              size="small"
              >新增区县</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="sort" label="排序" align="center" sortable />
      <el-table-column prop="city_name" label="城市名称" align="center" />
      <el-table-column prop="title" label="区县名称" align="center" />
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属城市" prop="city_id">
              <el-select
                v-model="form.city_id"
                placeholder="请选择"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="区县名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
                type="number"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import tableCommon from "../../../mixins/table-common";
import { getCityeList } from "../../api/city";
import {
  getdistrictList,
  addDistrict,
  editDistrict,
  deleteDistrict,
} from "../../api/district";
export default {
  mixins: [tableCommon],
  data() {
    return {
      regionTypes: [
        {
          label: 1,
          text: "启用",
        },
        {
          label: 0,
          text: "停用",
        },
      ],
      // 请求地址api
      api: {
        list: getdistrictList,
        add: addDistrict,
        del: deleteDistrict,
        edit: editDistrict,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入区县名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        city_id: [{ required: true, message: "请选择城市", trigger: "change" }],
      },
      // 传参
      form: {},
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
      // 城市下拉框
      cityList: "",
    };
  },
  mounted() {
    this.getCityeLists();
  },
  methods: {
    // 点击清空事件
    clearInput() {
      this.searchForm.city_id = undefined;
      this.initList();
    },
    clearInputs() {
      this.searchForm.title = undefined;
      this.initList();
    },
    // 城市下拉
    getCityeLists() {
      const form = {
        select: 1,
      };
      getCityeList(form).then((res) => {
        this.cityList = res.data.records;
      });
    },
    // 重置
    reset() {
      this.form = {
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      delete this.form.city_name;
      delete this.form.created_at;
      this.handleEdit();
    },
    // 重置
    resets() {
      this.searchForm = {
        city_id: undefined,
        title: undefined,
      };
      this.initList();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/district/index.vue